export default {
  definitions: {
    presentation: require('./presentation').default,
  },
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/addons/socialShare/index.js